import type { Batch } from '@ctcells/contract'
import { useSyncExternalStore } from 'react'

/** 셸 생명주기의 알림 장부. 캐시 재수신/StrictMode 재실행은 같은 발생을 다시 열지 않는다. */
export function createBatchHaltStore() {
  const seen = new Set<string>()
  let queued: readonly string[] = []
  const listeners = new Set<() => void>()
  const emit = (next: readonly string[]) => {
    queued = next
    listeners.forEach((listener) => listener())
  }
  return {
    subscribe: (listener: () => void) => {
      listeners.add(listener)
      return () => {
        listeners.delete(listener)
      }
    },
    snapshot: () => queued,
    observe(items: readonly Batch[]) {
      const fresh: string[] = []
      for (const batch of items) {
        // 사람의 일시정지는 표 밖(halt_code 없음)이므로 자동 알림 대상이 아니다.
        if (batch.status !== 'error' && !(batch.status === 'paused' && batch.halt_code != null))
          continue
        const key = JSON.stringify([batch.batch_id, batch.version])
        if (seen.has(key)) continue
        seen.add(key)
        fresh.push(batch.batch_id)
      }
      if (fresh.length > 0) emit([...new Set([...queued, ...fresh])])
    },
    open(batchId: string) {
      emit([...new Set([...queued, batchId])])
    },
    dismiss: () => {
      if (queued.length > 0) emit([])
    },
  }
}

export const batchHaltStore = createBatchHaltStore()
export function useBatchHaltIds() {
  return useSyncExternalStore(batchHaltStore.subscribe, batchHaltStore.snapshot)
}
